export default {
    MUST_EQUIP_AXE: 'Debes equipar un hacha para cortar árboles.',
    MUST_EQUIP_PICKAXE: 'Debes equipar un pico para minar rocas.',
    MUST_EQUIP_FISHING: 'Debes equipar una caña de pescar para poder pescar.',
    MUST_EQUIP_FORAGING: 'Necesitas una herramienta especial para forrajear esto.',

    INVALID_LEVEL_LUMBERJACKING: 'Debes tener el nivel {{level}} para cortar este árbol.',
    INVALID_LEVEL_MINING: 'Debes tener el nivel {{level}} para minar esta roca.',
    INVALID_LEVEL_FISHING: 'Debes tener el nivel {{level}} para poder pescar aquí.',
    INVALID_LEVEL_FORAGING: 'Debes tener el nivel {{level}} para recolectar este recurso.',

    UNABLE_TO_INTERACT_LUMBERJACKING: 'No puedes cortar este árbol en este momento.',
    UNABLE_TO_INTERACT_MINING: 'No tienes los conocimientos necesarios para minar esta roca.',
    UNABLE_TO_INTERACT_FISHING: 'No puede pescar aquí en este momento.',
    UNABLE_TO_INTERACT_FORAGING: 'No puedes recolectar este recurso en este momento.',

    NO_REASON_TREE: 'No hay razón para que cortes este árbol.',
    NO_REASON_FISHING: 'No hay razón para que pesques aquí.'
} as const;
